export default __webpack_public_path__ + "static/media/wise-logo.4a5c0444.png";